module.exports = __webpack_public_path__ + "img/smile.0957e9c5.png";